export const validateContactAddress = data => {
	return data.map(item => (!item.address_type ? { ...item, address_type: '' } : item))
}
